import React from 'react'
import PropTypes from 'prop-types'
import { withTheme } from 'styled-components'

import { Flex, Box } from '@chatterbug/aaron'

const ITEM_MARGIN = '1x'

const VocabularyWordListSkeleton = ({ ItemComponent, items, theme }) => {
  const negativeMargin = `-${theme.space[ITEM_MARGIN]}`

  return (
    <Flex
      flexWrap="wrap"
      alignContent="flex-start"
      mr={negativeMargin}
      mb={negativeMargin}
    >
      {items.map((word, index) => {
        return (
          <Box mr={ITEM_MARGIN} mb={ITEM_MARGIN} key={index}>
            <ItemComponent {...word} />
          </Box>
        )
      })}
    </Flex>
  )
}

VocabularyWordListSkeleton.propTypes = {
  ItemComponent: PropTypes.func,
  items: PropTypes.array,
}
export default withTheme(VocabularyWordListSkeleton)
